"use strict";
/** state: Final **/
/** family: MultiSelect **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Checkbox_1 = require("../Checkbox");
var constants_1 = require("../constants");
var DropdownButton_1 = require("../DropdownButton");
var Link_1 = require("../Link");
var MultiSelectCommon_1 = require("../MultiSelectCommon");
var SearchInput_1 = require("../SearchInput");
/**
 * Promises are not supported in IE11
 * Therefore a promise polyfill is required to support that browser.
 */
require("promise-polyfill/dist/polyfill");
var CLASS_NAME = 'i-multiselect-search';
/**
 * This filter allows the user to select multiple selections from a large list of options (20+).
 * When the filter list is open, it allows the user to optionally search for items within the list,
 * stopping the user having to scroll through many options.
 * When the user reopens the list, the selected options sit at the top of the list,
 * so the user doesn't have to scroll down the list to deselect them.
 * The options can be lazy loaded if there are many, many options.
 */
var MultiSelectSearch = /** @class */ (function (_super) {
    __extends(MultiSelectSearch, _super);
    function MultiSelectSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.getCommonProps = function () {
            return {
                id: _this.props.id,
                label: _this.props.label,
                metricOptions: _this.props.metricOptions,
                selectedItems: _this.props.selectedItems,
                selectedText: _this.props.selectedText,
            };
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            _this.setState({ searchText: value, isLoading: true }, function () {
                _this.changeSubject.next(value);
            });
        };
        _this.handleClear = function () {
            _this.setState({ searchText: '', searchResults: [] }, function () {
                _this.changeSubject.next('');
                // Save selected items to state when the search text is changed.
                _this.saveSelectedItemsToState();
            });
        };
        _this.shouldRenderSelectAll = function () {
            var _a = _this.props, onSelectAll = _a.onSelectAll, selectAllLinkText = _a.selectAllLinkText;
            return !!(selectAllLinkText && onSelectAll);
        };
        _this.renderSelectAll = function () {
            if (!_this.shouldRenderSelectAll()) {
                return;
            }
            return (React.createElement(Link_1.Link, { href: "javascript:void(0);", label: _this.props.selectAllLinkText, onClick: _this.handleSelectAll, className: CLASS_NAME + "__select-all-link" }));
        };
        _this.handleSelectAll = function (e) {
            _this.props.onSelectAll(e, _this.getSearchResultsItems().concat(_this.getSelectedItems()));
        };
        _this.handleToggle = function (isVisible) {
            // If visibility is changed and is `true`:
            if (isVisible) {
                // Save selected items to state.
                _this.saveSelectedItemsToState();
                // Also clear the search input box and search results.
                _this.setState({
                    searchResults: [],
                    searchText: '',
                });
            }
        };
        _this.saveSelectedItemsToState = function () {
            _this.setState({
                selectedItemsInternal: _this.props.selectedItems,
            });
        };
        _this.handleSelect = function (e, getSelectedItemsOnSelect, item) {
            e.stopPropagation();
            _this.props.onSelect(e, getSelectedItemsOnSelect(_this.props.selectedItems, item), item);
        };
        _this.getSelectedItems = function () {
            var items = _this.isInSearchMode()
                ? _this.filterSelectedItems(_this.state.selectedItemsInternal, _this.state.searchResults)
                : _this.state.selectedItemsInternal;
            return items.length === 0 ? [] : items;
        };
        _this.renderSelectedItems = function (getSelectedItemsOnSelect, isSelected) {
            if (_this.state.selectedItemsInternal.length === 0) {
                return [];
            }
            var items = _this.getSelectedItems();
            return [_this.renderDivider('divider-selected')].concat(_this.renderItems(items, _this.props.selectedItems, getSelectedItemsOnSelect, isSelected));
        };
        /**
         * Remove selected items which do not match the search criteria.
         */
        _this.filterSelectedItems = function (selectedItems, searchResults) {
            var searchResultValues = searchResults.map(function (opt) { return opt.value; });
            return selectedItems.filter(function (item) { return searchResultValues.indexOf(item.value) !== -1; });
        };
        _this.getSearchResultsItems = function () {
            var items = _this.isInSearchMode()
                ? _this.state.searchResults
                : _this.props.defaultItems;
            return _this.removeSelectedItemsFromResults(items, _this.state.selectedItemsInternal);
        };
        _this.renderSearchResults = function (getSelectedItemsOnSelect, isSelected) {
            var items = _this.getSearchResultsItems();
            var searchResults = []
                .concat(_this.renderItems(items.slice(0, _this.props.maxItems), _this.props.selectedItems, getSelectedItemsOnSelect, isSelected), _this.shouldRenderNoResultsMessage() &&
                _this.renderNoResultsMessage(), _this.shouldRenderMoreResultsMessage(items.length) &&
                _this.renderMoreResultsMessage())
                .filter(function (item) { return !!item; });
            return (searchResults.length > 0 &&
                [].concat(_this.renderDivider('divider-other'), searchResults));
        };
        /**
         * Remove selected items from the search results as it is already displayed
         * in the selected items section.
         */
        _this.removeSelectedItemsFromResults = function (searchResults, selectedItems) {
            var selectedValues = selectedItems.map(function (item) { return item.value; });
            return searchResults.filter(function (result) { return selectedValues.indexOf(result.value) === -1; });
        };
        _this.renderItems = function (items, selectedItems, getSelectedItemsOnSelect, isSelected) {
            return items.map(function (item, index) { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: index, onClick: function (event) {
                    return _this.handleSelect(event, getSelectedItemsOnSelect, item);
                } },
                React.createElement(Checkbox_1.Checkbox, { label: item.label, checked: isSelected(selectedItems, item) }))); });
        };
        _this.renderDivider = function (key) { return (React.createElement(DropdownButton_1.DropdownButton.Item, { divider: true, key: key })); };
        _this.renderNoResultsMessage = function () { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: "no-results", readOnly: true, className: CLASS_NAME + "__item--no-results" }, _this.props.noResultsText)); };
        _this.renderMoreResultsMessage = function () { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: "too-many-results", readOnly: true, className: CLASS_NAME + "__item--too-many-results" }, _this.props.moreResultsText)); };
        _this.isInSearchMode = function () { return !!_this.state.searchText; };
        _this.subscribeToChange = function () {
            _this.changeSubject = new rxjs_1.Subject();
            _this.changeSubscription = _this.changeSubject
                .pipe(operators_1.debounceTime(_this.props.debounceTime), operators_1.distinctUntilChanged(), operators_1.switchMap(function (value) { return rxjs_1.from(_this.props.onSearch(value)); }))
                .subscribe(function (searchResults) {
                _this.setState({ searchResults: searchResults, isLoading: false });
                // Save selected items to state when search text is changed.
                _this.saveSelectedItemsToState();
            });
        };
        _this.unsubscribeFromChange = function () {
            _this.changeSubscription.unsubscribe();
        };
        _this.state = {
            isLoading: false,
            searchResults: [],
            searchText: '',
            selectedItemsInternal: [],
        };
        return _this;
    }
    MultiSelectSearch.prototype.componentDidMount = function () {
        this.subscribeToChange();
    };
    MultiSelectSearch.prototype.componentWillUnmount = function () {
        this.unsubscribeFromChange();
    };
    MultiSelectSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onReset = _a.onReset, resetFilterLinkText = _a.resetFilterLinkText, searchInputPlaceholderText = _a.searchInputPlaceholderText;
        return (React.createElement(MultiSelectCommon_1.MultiSelectCommon, __assign({ className: classNames(CLASS_NAME, className), onToggle: this.handleToggle, onOutsideClick: this.handleClear }, this.getCommonProps()), function (_a) {
            var getSelectedItemsOnSelect = _a.getSelectedItemsOnSelect, isSelected = _a.isSelected;
            return [
                React.createElement(DropdownButton_1.DropdownButton.Item, { key: "search", readOnly: true },
                    React.createElement(SearchInput_1.SearchInput, { className: CLASS_NAME + "__search-input", onChange: _this.handleChange, onClear: _this.handleClear, placeholder: searchInputPlaceholderText, showLoader: _this.state.isLoading, value: _this.state.searchText }),
                    React.createElement(Link_1.Link, { href: "javascript:void(0);", label: resetFilterLinkText, onClick: onReset, className: CLASS_NAME + "__reset-link" }),
                    _this.renderSelectAll()),
                _this.renderSelectedItems(getSelectedItemsOnSelect, isSelected),
                _this.renderSearchResults(getSelectedItemsOnSelect, isSelected),
            ];
        }));
    };
    MultiSelectSearch.prototype.shouldRenderNoResultsMessage = function () {
        var itemsList = this.isInSearchMode()
            ? this.state.searchResults
            : this.props.defaultItems;
        return !this.state.isLoading && itemsList.length === 0;
    };
    MultiSelectSearch.prototype.shouldRenderMoreResultsMessage = function (filteredResultsLength) {
        return (this.props.moreResultsText &&
            filteredResultsLength > this.props.maxItems);
    };
    MultiSelectSearch.defaultProps = {
        debounceTime: constants_1.DEFAULT_DEBOUNCE_TIME,
        defaultItems: Array(),
    };
    return MultiSelectSearch;
}(React.Component));
exports.MultiSelectSearch = MultiSelectSearch;
//# sourceMappingURL=MultiSelectSearch.js.map